import { render, staticRenderFns } from "./no-permissions.vue?vue&type=template&id=95b41df4&scoped=true"
import script from "./no-permissions.vue?vue&type=script&lang=js"
export * from "./no-permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b41df4",
  null
  
)

export default component.exports